export default __webpack_public_path__ + "static/media/arrow_top_up.56ee495e.svg";